@use "../../../styles/Colors.scss" as Colors;
@use "../../../styles/Constants.scss" as Constants;

.SelectAll {
	display: inline-block;

	.icon {
		font-size: Constants.$val-icon20;
		color: Colors.$col-greyMid;
		transition: color 0.1s;
	}

	&:hover {
		.icon {
			color: Colors.$color-orange;
		}
	}
}
